import { ApiUrls } from '@api/apiUrls';
import { fetchApi } from '@api/fetchApi';
import { pushAccountCreateSuccessfulEvent } from '@components-shared/googleAnalyticsEvents';
import { getClientSourceType } from '@components-shared/utils/getClientSourceType';
import { IUser } from 'global.interfaces';

export interface IAccountCreatedResponse {
  idHash: string;
  accountType: string;
  id: number;
  login: number;
}

export const createSelfTradeAccount = async <T extends Record<string, unknown>>(
  form: T,
  user: IUser,
): Promise<IAccountCreatedResponse> => {
  const response = await fetchApi.post<IAccountCreatedResponse>(
    ApiUrls.tradingAccountUser.selfTradeAccountCreate,
    form,
  );

  accountCreatedSuccessfullyEvent(response.data.idHash, form, user, response.data.accountType);

  return response.data;
};

export const accountCreatedSuccessfullyEvent = <T extends { leverage?: number | string }>(
  accountIdHash: string,
  form: T,
  user: IUser,
  accountType: string,
): void => {
  pushAccountCreateSuccessfulEvent(
    user.idHash,
    getClientSourceType(user.profile.clientSourceType),
    accountIdHash,
    accountType,
    user.profile.status,
    form.leverage,
  );
};
